import * as types from './mutations-types'

const mutations = {
  SETTOKEN (state, payload) {
    state.token = payload
  },
  CUSTOMERID (state, payload) {
    state.customerId = payload
  },
  USERID (state, payload) {
    state.userId = payload
  },
  ORDERID (state, payload) {
    state.orderId = payload
  },
  LOGIN (state, payload) {
    state.login = payload
  },
  USERINFO (state, payload) {
    state.userInfo = payload
  },
  ORDERINFO (state, payload) {
    state.orderInfo = payload
  },
  BOOKINFO (state, payload) {
    state.bookInfo = payload
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js